/**
 * Action creator for removing an account. Server handles cascade
 * behaviour (refuses with errorCode=1 + 500 if the account owns
 * patients / claims / orders — see legacy AccountsList handling).
 *
 * Endpoint: DELETE /accounts/{uuid}
 */
export const deleteAccountAction = ({ uuid }) => ({
  method: 'DELETE',
  endpoint: `/accounts/${uuid}`,
});
